import React, { useMemo } from 'react';
import Itly, { ClickedCartDetailsProperties } from 'itly';
import Icon from 'components/icons';

interface useCartItemActionsProps {
  buttons: JSX.Element[];
  productOptionPriceTransparencySplit: boolean;
  isEditable: boolean;
  shouldRenderEditButton: (project: any) => boolean;
  isBrassWoodDisplayBoxWithPrints: boolean;
  showCustomOptionPrices: boolean;
  cartItemOptionPriceDetails: any;
  showPriceDetails: boolean;
  setShowPriceDetails: (value: boolean) => void;
  item: any;
  email: string;
  project: any;
  editorUrl: string;
  isDeviceSmall: boolean;
}

export const useCartItemActions = ({
  buttons,
  productOptionPriceTransparencySplit,
  isEditable,
  shouldRenderEditButton,
  isBrassWoodDisplayBoxWithPrints,
  showCustomOptionPrices,
  cartItemOptionPriceDetails,
  showPriceDetails,
  setShowPriceDetails,
  item,
  email,
  project,
  editorUrl,
  isDeviceSmall
}: useCartItemActionsProps): React.DependencyList => {
  return useMemo(() => {
    let actions = [...buttons];
    const style = productOptionPriceTransparencySplit
      ? { fontSize: '12px', lineHeight: '150%', letterSpacing: '1px', weight: 600 }
      : {};

    if ((isEditable && shouldRenderEditButton(project)) || isBrassWoodDisplayBoxWithPrints) {
      actions = [
        <button style={style} onClick={editProjectHandler(editorUrl)} key="edit">
          Edit
        </button>,
        ...actions
      ];
    }

    if (showCustomOptionPrices && cartItemOptionPriceDetails.upchargedProductOptions.length > 0) {
      const iconName = showPriceDetails ? 'smallBoldMinus' : 'smallBoldPlus';
      actions = [
        <button
          style={{
            ...style,
            marginRight: 'auto',
            display: 'flex',
            alignItems: 'center',
            marginLeft: '25px'
          }}
          onClick={() => {
            const eventData: ClickedCartDetailsProperties = {
              email,
              cart_id: parseInt(item.quote_id),
              clicked_to_expand: !showPriceDetails
            };
            Itly.clickedCartDetails(eventData);
            setShowPriceDetails(!showPriceDetails);
          }}
          key="priceDetails"
        >
          <span style={{ paddingRight: '8px' }}>{`${isDeviceSmall ? 'Details' : 'Price Details'}`}</span>
          <Icon icon={iconName} />
        </button>,
        ...actions
      ];
    }

    return actions;
  }, [
    buttons,
    productOptionPriceTransparencySplit,
    isEditable,
    shouldRenderEditButton,
    isBrassWoodDisplayBoxWithPrints,
    showCustomOptionPrices,
    cartItemOptionPriceDetails,
    showPriceDetails,
    setShowPriceDetails,
    item,
    email,
    project,
    editorUrl,
    isDeviceSmall
  ]);
};

const editProjectHandler = (editorUrl: string) => () => {
  window.location.href = editorUrl;
};
